import { render, staticRenderFns } from "./OurPicks.vue?vue&type=template&id=74fff92f&"
import script from "./OurPicks.vue?vue&type=script&lang=js&"
export * from "./OurPicks.vue?vue&type=script&lang=js&"
import style0 from "./OurPicks.vue?vue&type=style&index=0&id=74fff92f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports